import React, { createContext, useContext, useState, useEffect } from "react";

const ProjectFilterContext = createContext();

export const useProjectFilter = () => {
  const context = useContext(ProjectFilterContext);
  if (!context) {
    throw new Error("useProjectFilter must be used within ProjectFilterProvider");
  }
  return context;
};

export const ProjectFilterProvider = ({ children }) => {
  const [selectedProjectId, setSelectedProjectId] = useState(() => {
    // Initialize from localStorage if available
    const saved = localStorage.getItem("selectedProjectId");
    if (saved === "without-project") {
      return "without-project";
    }
    return saved ? parseInt(saved, 10) : null;
  });

  // Persist to localStorage whenever it changes
  useEffect(() => {
    if (selectedProjectId !== null) {
      localStorage.setItem("selectedProjectId", selectedProjectId.toString());
    } else {
      localStorage.removeItem("selectedProjectId");
    }
  }, [selectedProjectId]);

  return (
    <ProjectFilterContext.Provider value={{ selectedProjectId, setSelectedProjectId }}>
      {children}
    </ProjectFilterContext.Provider>
  );
};
